export default {
  path: "/user/tareas",
  component: () => import("@/views/user/tareas/TareasLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
  },
  children: [
    {
      path: "",
      name: "tareas-mis",
      component: () => import("@/views/user/tareas/MisTareasView.vue"),
    },
    {
      path: "grupo",
      name: "tareas-grupo",
      component: () => import("@/views/user/tareas/TareasGrupoView.vue"),
    },
    {
      path: "nueva",
      name: "tareas-nueva",
      component: () => import("@/views/user/tareas/TareaEditorView.vue"),
    },
    {
      path: ":taskId",
      name: "tareas-detalle",
      component: () => import("@/views/user/tareas/TareaDetalleView.vue"),
      props: true,
    },
  ],
};
